import { Mapper } from "planning-portal-library/src/lib/core/base";
import { LocationsToAddInJobs } from "planning-portal-library/src/lib/core/domain";
import { LocationsToAddInJobEntity } from "./locations-to-add-in-job-web-entity";


export class LocationsToAddInJobWebRepositoryMapper extends Mapper<LocationsToAddInJobEntity, LocationsToAddInJobs> {
  mapFrom(param: LocationsToAddInJobEntity): LocationsToAddInJobs {
    return {
      locationId: param.locationId,
      address: param.address,
      locationName: param.locationName,
      locationNameAndAddress: param.locationNameAndAddress,
      serviceTime :param.serviceTime ,
      serviceToTime  :  param.serviceToTime ,
      productId  : param.productId
    };
  }

  mapTo(param: LocationsToAddInJobs): LocationsToAddInJobEntity {
    return {
      locationId: param.locationId,
      address: param.address,
      locationName:param.locationName,
      locationNameAndAddress: param.locationNameAndAddress,
      serviceTime : param.serviceTime,
      serviceToTime  : param.serviceToTime,
      productId  : param.productId
    };
  }

}
